import LegacyViewportActionBar from './LegacyViewportActionBar';
export default LegacyViewportActionBar;
